// extracted by mini-css-extract-plugin
export var editButton = "_m2-0";